// ConnectionDot — wallet/connection status indicator. Consumes the
// existing --phase-verified token so the green is single-sourced.
//
// Used by Address (full variant), WalletPill, and subscribe-fund-flow's
// SendingCard. ChainPill is intentionally NOT a consumer — its emerald
// is documented as one-off brand-external chrome (see ChainPill.tsx).

export type ConnectionDotStatus = 'connected' | 'offline';

export type ConnectionDotProps = {
  status?: ConnectionDotStatus;
  className?: string;
};

export function ConnectionDot({
  status = 'connected',
  className,
}: ConnectionDotProps) {
  const bg =
    status === 'connected'
      ? 'var(--phase-verified)'
      : 'rgba(45, 45, 45, 0.4)';
  return (
    <span
      aria-hidden
      className={`inline-block rounded-full shrink-0 ${className ?? 'w-2 h-2'}`}
      style={{ background: bg }}
    />
  );
}
